import './Footer.scss'
import React from 'react'


export default function Footer(props) {
  return (
    <footer className="app-layout-footer custom-footer">
      <p className="footer-content custom-footer-content" />
    </footer>
  )
}
